<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="卡号：" prop="card_code">
                <el-input v-model="model.card_code"></el-input>
            </el-form-item>
            <el-form-item label="运营商：" prop="operator">
                <el-input v-model="model.operator"></el-input>
            </el-form-item>
            <el-form-item label="流量套餐：" prop="flow_package">
                <el-input v-model="model.flow_package"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'netCardEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                card_code: '',
                operator: '',
                flow_package: '',
                state: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/netcard/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                card_code: [
                    {required: true, message: '卡号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                operator: [
                    {required: true, message: '运营商不能为空', trigger: 'blur'}
                ],
                flow_package: [
                    {required: true, message: '流量套餐不能为空', trigger: 'blur'}
                ],
            },
            checkObj:{
                url:'/api/admin/netcard/check',
                data:{}
            },
            exits_p_name:'card_code',
            exits_p_title:'卡号',
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/netcard/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>